const cardItems = [
  {
    title: '2026最值得收藏的100个实用网站',
    desc: '涵盖工具、学习、设计、开发等八大类别，网址导航123帮你整理好了。',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20colorful%20website%20bookmark%20icons%20arranged%20in%20a%20grid%20on%20a%20warm%20cream%20background%2C%20clean%20minimalist%20composition%2C%20soft%20orange%20and%20coral%20accent%20touches%2C%20editorial%20flat%20lay%20style&width=800&height=500&seq=card-sites-01&orientation=landscape',
    tag: '网址收藏',
    tagColor: 'primary' as const,
  },
  {
    title: '每天五分钟看懂社会热点',
    desc: '精选每日最热社会话题，导航123帮你快速了解来龙去脉和各方观点。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20newspaper%20and%20news%20concept%20with%20floating%20text%20fragments%20on%20a%20warm%20neutral%20background%2C%20minimalist%20design%2C%20soft%20amber%20tones%2C%20clean%20editorial%20aesthetic&width=800&height=500&seq=card-news-02&orientation=landscape',
    tag: '社会热点',
    tagColor: 'accent' as const,
  },
  {
    title: '在线导航隐私安全完全指南',
    desc: '上网导航时如何保护个人隐私？51网址导航提供安全上网建议和工具推荐。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20privacy%20concept%20with%20abstract%20shield%20and%20lock%20elements%20on%20a%20warm%20cream%20background%2C%20minimalist%20composition%2C%20soft%20coral%20accent%2C%20clean%20modern%20design&width=800&height=500&seq=card-privacy-03&orientation=landscape',
    tag: '安全指南',
    tagColor: 'secondary' as const,
  },
  {
    title: '从零开始搭建个人效率工具库',
    desc: '利用51网址导航的网址123功能，打造属于你自己的上网导航工作流。',
    image: 'https://readdy.ai/api/search-image?query=Productivity%20workspace%20concept%20with%20abstract%20notebook%20and%20digital%20tools%20on%20a%20warm%20minimal%20background%2C%20clean%20geometric%20layout%2C%20soft%20orange%20tones%2C%20editorial%20style&width=800&height=500&seq=card-productivity-04&orientation=landscape',
    tag: '效率提升',
    tagColor: 'primary' as const,
  },
  {
    title: '网购达人都在用的比价导航技巧',
    desc: '学会这几招比价导航方法，618和双11购物不再被套路，省钱又省心。',
    image: 'https://readdy.ai/api/search-image?query=Smart%20shopping%20concept%20with%20abstract%20price%20tags%20and%20magnifying%20glass%20on%20a%20warm%20cream%20background%2C%20minimalist%20design%2C%20soft%20coral%20and%20gold%20tones%2C%20clean%20editorial%20aesthetic&width=800&height=500&seq=card-shopping-05&orientation=landscape',
    tag: '购物技巧',
    tagColor: 'accent' as const,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            编辑精选的优质内容，帮你更好地使用上网导航服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`${i === 0 ? 'flex flex-col sm:flex-row' : ''}`}>
                <div className={`relative overflow-hidden ${i === 0 ? 'sm:w-2/5 aspect-[4/3] sm:aspect-auto' : 'aspect-[8/5]'}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    width="800"
                    height="500"
                  />
                </div>
                <div className={`p-4 md:p-5 ${i === 0 ? 'sm:w-3/5' : ''}`}>
                  <span className={`inline-block text-[10px] font-semibold px-2 py-0.5 rounded-full mb-2 ${
                    item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' :
                    item.tagColor === 'accent' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <h3 className="font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}